const LISTAR_DADOS = (state, payload) => {
    state.items = payload
  }

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_MODULO_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_MODULO = (state,  payload) => {
  state.items.push(payload)
}

const ATUALIZAR_MODULO = (state, payload) => {
  state.items = state.items.map(modulo => {
    if(modulo.id === payload.id) {
      return payload;
    }
    return modulo
  })
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_MODULO_SELECIONADO,
    INSERIR_MODULO,
    ATUALIZAR_MODULO
}